import React, { memo, forwardRef } from "react";
const SvgTranspose = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        stroke="#717171"
        strokeWidth={0.3}
        d="M24.248 6.666h0v-.003a.91.91 0 00.021-.172.779.779 0 00-.02-.165.552.552 0 00-.106-.226.546.546 0 00-.227-.182.792.792 0 00-.35-.068h-4.053a.851.851 0 00-.357.067h0l-.004.002a.635.635 0 00-.221.176h0l-.007.01a.779.779 0 00-.114.387c0 .049.008.108.02.171h0l.001.003a.626.626 0 00.093.212h0l.007.009a.635.635 0 00.22.175h0l.005.003a.851.851 0 00.357.067h1.314v4.634c0 .15.023.286.079.398h0l.002.004c.048.09.106.167.175.228h0l.006.005c.074.06.157.1.248.119.07.019.14.03.203.03a.8.8 0 00.203-.03.513.513 0 00.242-.121.752.752 0 00.187-.231h0l.002-.004a.889.889 0 00.078-.398V7.132h1.314c.13 0 .25-.02.35-.068a.546.546 0 00.227-.182.555.555 0 00.105-.216z"
      />
      <rect width={10} height={14} x={9} y={12.328} fill="#DBDBDB" rx={2} />
    </svg>
  );
});
SvgTranspose.displayName = "SvgTranspose";
const MemoForwardRef = memo(SvgTranspose);
export default MemoForwardRef;
